import Link from "next/link";
import { PropsWithChildren } from "react";

const FooterLink = ({ to, children }: PropsWithChildren<{ to: string }>) => (
  <Link href={to} className="px-2" target="_blank">
    {children}
  </Link>
);

export default FooterLink;
